import { isGamesTheme } from "@utils";
import { PopupComponentsEnum } from "@components/popups/shared/PopupComponentsEnum";

export default class BlockPopupComponentsService {
	//used inside welcome popup and required user actions popup
	static checkIfComponentBlocked(popupComponent: PopupComponentsEnum) {
		const blockedWelcomePopupComponents = [
			PopupComponentsEnum.DepositLimitInfo,
			PopupComponentsEnum.CreditRatingInfo,
			PopupComponentsEnum.BettingDisabledInfo,
			PopupComponentsEnum.DocumentExpirationInfo,
			PopupComponentsEnum.UseMarketplaceBonus,
		];

		return (
			isGamesTheme() &&
			blockedWelcomePopupComponents.includes(popupComponent)
		);
	}
}
